import { ReactNode, useState, useEffect } from 'react';
import styles from './thumbnail-menu.module.css';
import { blockSeparator } from './util-styles';
import { useEnvConfig } from '../app/context/environment-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { MaterialsType } from '../view/configurator-q-material';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { showPopup } from '../app/popup-slice';
import { catalogSelector } from '../app/configurator-selectors';

interface imageTypes {
    MATERIAL: MaterialsType
    COLOR: MaterialsType
    TAG: MaterialsType    
}
export const IMAGE_TYPE: imageTypes = {
    MATERIAL:"material",
    COLOR: "color",
    TAG: "tag"
}

interface Thumbnail {
    qualityPath?: string
    code: string
    name: string
    material?: string
    definition?: Object
    mainColor?: string
    tags?: string[]
    qualityId? : string
}

export const ThumbnailMenu = ({ children, className, imgWidth }: {
    children?: ReactNode
    className?: string
    imgWidth?: number
}) => {
    return <ul className={`${styles.thumbnailMenu} ${blockSeparator}`}>{children}</ul>
}

export const ThumbnailMenuItem = ({ image, imgWidth, imgHeight, name, selected, onClick, type, onClickInfo, disabled }: {
    image: string
    imgWidth?: number
    imgHeight?: number
    name?: string
    selected?: boolean
    onClick: () => void
    type: MaterialsType | "base"
    onClickInfo?: (event: React.MouseEvent) => void 
    disabled?: boolean
}) => {

    return <li className={`${styles.tmItem} ${selected ? styles.selected : ''} ${disabled ? styles.disabled : ''}`}>
        <div className={styles.tmItemDiv} style={{ height: imgHeight}} onClick={!disabled ? onClick : undefined}>
            <img src={image} width={imgWidth} height={imgHeight}/>
            {
                name &&
                <div className={styles.container}>
                    <span className={styles.tmName}>
                        {name}                        
                    </span> 
                    {type === IMAGE_TYPE.MATERIAL && <span onClick={onClickInfo}>
                        <FontAwesomeIcon icon={faCircleInfo} className={styles.infoIcon} />
                    </span>}
                </div>                
            }
        </div>
    </li>
}

export const ThumbnailMenuList = ({ className, thumbnailList: thumbnaiList, type, selectedCode, onHandleSeletedThumb, materialName, materialId }:{
    thumbnailList: Thumbnail[]
    onHandleSeletedThumb: (color: string, type: MaterialsType) => void
    type: MaterialsType
    materialName?: string
    materialId?: string
    selectedCode?: string
    className?: string
}) => {
    const { thumbnailsPath, thumbnailWidth, thumbnailHeight } = useEnvConfig();
    const dispatch = useAppDispatch()
    const { qualities } = useAppSelector(catalogSelector);
    
    const [selectedMaterial, setSelectedMaterial] = useState<string | undefined>(undefined);


    const popupContent = () => {
        const materialInfo = qualities.find(q => q.qualityId === selectedMaterial)
        return materialInfo;
    }

    useEffect(()=>{
        if(selectedMaterial){
            dispatch(showPopup({popupContent: popupContent(), dialog: 'infoQuality'}))
            setSelectedMaterial(undefined)
        }
    },[ selectedMaterial ])

    const onHandleClickInfo = (event: React.MouseEvent, color: string) => {
        event.stopPropagation()
        setSelectedMaterial(color)
    }

    const urlImage = (thumb: Thumbnail, index: number) => {
        const imageTags =[ `${thumbnailsPath}/materials/celia/cherry.png`,`${thumbnailsPath}/materials/dodo/c0205.png`]

        switch(type){
            case IMAGE_TYPE.MATERIAL:
                return `${thumbnailsPath}/materials/${thumb.code}/quality-index.webp`;
            case IMAGE_TYPE.TAG:
                return imageTags[index];
            case IMAGE_TYPE.COLOR:
                return `${thumbnailsPath}/materials/${thumb?.qualityPath}/${thumb.code}.png`;
            default:
                return "";
        }
    }            
        
    return (
        <>
            {(type === IMAGE_TYPE.COLOR && materialName) && <p className={styles.materialTitle}>{materialName}</p>}

                        <ul id="thumbnailMenu" className={`${styles.thumbnailMenu} ${blockSeparator} ${className}`}>
                {thumbnaiList.map((thumb: Thumbnail, index: number) => {
                    const codeName = materialId ? `${materialId}/${thumb.code}` : thumb.code;
                    return (
                        // Check if material is defined in materials.json
                        thumb.code && thumb.code.trim() !== "" && (
                            <ThumbnailMenuItem 
                                key={`${thumb.code}${index}`} 
                                image={urlImage(thumb, index)} 
                                name={thumb.name}
                                imgWidth={thumbnailWidth}
                                imgHeight={thumbnailHeight}
                                selected={codeName === selectedCode}
                                onClick={() => {
                                    onHandleSeletedThumb(codeName, type);
                                    // Find the scrollable ul and scroll to the top
                                    if(type === IMAGE_TYPE.MATERIAL) {
                                        const thumbnailMenu = document.getElementById("thumbnailMenu");
                                        if (thumbnailMenu) {
                                          thumbnailMenu.scrollTo({ top: 0, behavior: "smooth" });
                                        }
                                    }
                                }}                               
                                type={type}
                                onClickInfo={(e) => onHandleClickInfo(e, thumb?.qualityId ?? "")}
                            />
                        )
                    );
                })}
            </ul>
        </>
    )}